/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view: {
        'class':'section section-bottom',
        $html:[{
            'class': 'bg-fixed abs-full',
            // $html:{
            //     'class':'bg-mask'
            // }
        },{
            'class':'section-content abs-full',
            $html:[{
                'class':'title-en',
                $text:'We select best wines'
            },{
                'class':'title-cn',
                $text:nb.bind('title')
            },{
                'class':'input-group clearfix',
                $html:[{
                    'class':'input',
                    tag:'input',
                    value:nb.bind('emailValue'),
                    placeholder:nb.bind('placeholder')  //Email Address
                },{
                    $name:'btnRegister',
                    'class':'btn btn-register',
                    $text:nb.bind('btnRegister')
                }]
            }]
        }]
    },
    method:{
        init:function () {
            var self = this;

            //点击提交邮箱
            this.$('btnRegister').on('click',function () {
                self.getModel().set('requireSubmitEmail',new Date())
            })
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/bottom/Section.js
// module id = 513
// module chunks = 6